import { render } from "./Tour.vue?vue&type=template&id=72dca6aa"
import script from "./Tour.vue?vue&type=script&lang=js"
export * from "./Tour.vue?vue&type=script&lang=js"

import "./Tour.vue?vue&type=style&index=0&id=72dca6aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__